export default "__VITE_ASSET__DqYTAuiS__"